exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".gunnarDescription {\n  Width: 90%;\n  text-align: left;\n  box-shadow: 3px 3px 3px rgba(0, 0, 0, 0.2);\n  margin-top: 5%;\n}\n.contents.gunnar {\n  display: -webkit-flex;\n  display: flex;\n  -webkit-flex-direction: column;\n          flex-direction: column;\n  -webkit-align-items: center;\n          align-items: center;\n  justify-items: center;\n  overflow: scroll;\n}\n#gunnar {\n  height: 100vh;\n  min-height: 100vh;\n  display: -webkit-flex;\n  display: flex;\n  -webkit-flex-direction: row;\n          flex-direction: row;\n  -webkit-justify-content: center;\n          justify-content: center;\n  \n  \n  /* width: 100%; */\n}", ""]);

// exports
